<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { createPromiseStore } from "../../../core/utils/createPromiseStore.js";
	import { getClients } from "../appsync/getClients.js";
	import { loggedCustomerStore } from "../stores/loggedCustomerStore.js";
	import Button from "../components/Button.svelte";
	import { onMount } from "svelte";
	import { signInPathMap } from "../../../core/schema/paths/signInPathMap.js";
	import Vouchers from "../components/MyAccount/Vouchers.svelte";
	import Orders from "../components/MyAccount/Orders.svelte";
	import type { MyAccountProps } from "./MyAccountProps";

	type $$Props = MyAccountProps;

	const { products, vouchers } = $$restProps as $$Props;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;

	const logout = createPromiseStore(async () => {
		const { cognito } = await getClients(globalSettings);
		await cognito.logout();
		loggedCustomerStore.set(undefined);
	});

	async function signOut(): Promise<void> {
		await logout.call();
		window.location.href = "/";
	}

	onMount(() => {
		if ($loggedCustomerStore.value === undefined) {
			window.location.href = `/${signInPathMap[TENANT_LOCALE]}`;
		}
	});
</script>

<Layout>
	<div class="container flex w-full flex-col">
		<div class="flex flex-col items-center gap-8 md:gap-[48px]">
			<h1 class="m-0 self-start text-xl md:text-2xl">{nbspify("Můj Sladký účet")}</h1>

			<Vouchers />
			<Orders {products} {vouchers} />

			<Button on:click={signOut}>Odhlásit se</Button>
		</div>
	</div>
</Layout>
